import ActivityData from './activity-data';
import ResourceList from './resource-apply-list';
import ResourceManage from './resource-manage';
import ResourceChildren from './resource-list/route-config';
import ResourceSquareMent from './resource-square/route-config';

export default [
  // TOFIX: 路由和slide-menu的配置在这里不能统一
  // /activity-data/*这个path无法用在slide-menu中
  // 所以使用了/activity-data/data/home复写了这个路由
  {
    // menuId: 37,
    title: '活动数据',
    path: '/activity-data/data/home',
    component: ActivityData,
  },
  {
    // menuId: 24,
    title: '资源位列表',
    path: '/resource-list',
    menus: ResourceChildren,
    // component: ResourceList
  },
  {
    // menuId: 12,
    title: '申请管理',
    path: '/resource-manage',
    component: ResourceManage,
  },
  {
    // menuId: 37,
    title: '活动数据',
    path: '/activity-data/*',
    component: ActivityData,
    hideInNav: true,
  },
  {
    // menuId: 36,
    title: '申请列表',
    path: '/resource-apply-list',
    component: ResourceList,
  },
  {
    // menuId: 2,
    title: '资源广场',
    path: '/resource-square',
    menus: ResourceSquareMent,
  },
];
